<template>
  <div class="main order">
    <sh-navbar :tab-title="tabTitle" :current-tab-index="currentTabIndex" :scroll-disabled="scrollDisabled" @tabChange="tabChange">
      <van-search v-model="SearchKey" show-action placeholder="输入商品名称或订单编号搜索" slot="searchBox" shape="round" maxlength="200" @search="onSearch">
        <template #action>
          <div @click="onSearch" class="searchBtn">搜索</div>
        </template>
      </van-search>
      <template v-for="(item, index) in tabTitle">
        <template v-if="dataList.length > 0 && currentTabIndex === index" :slot="`tab-cnt${index}`">
          <div :key="index" class="order-list-mian" v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
            <order-item
              v-for="order in dataList"
              :key="order.PlatformOrderID"
              :item="order"
              @entoDetailPage="entoDetailPage"
              @waitAudit="waitAudit"
              @cancelOrder="orderPageCancel"
              @checkPeiceFeedback="checkPeiceFeedback"
              @deleteOrder="deleteOrder"
              @continueSubmit="continueSubmit"
              @submitSearch="submitSearch"
              @submitAgain="submitAgain"
              @confirmReceipt="confirmReceipt"
              @checkRebate="checkRebate"
            />
          </div>
        </template>
      </template>
      <div slot="nav-bottom">
        <segement-Line v-if="!haveMore" line-text="没有更多订单了"> </segement-Line>
        <segement-Line v-else :is-load="true"> </segement-Line>
      </div>
    </sh-navbar>
    <!-- 领取返利弹窗 -->
    <sh-dialog
      v-if="dialogIsShow"
      :task-id="taskId"
      :product-id="productId"
      :platform-type="platformType"
      :is-logistics-finished="isLogisticsFinished"
      :is-exist-logistics-audit="isExistLogisticsAudit"
      :is-trade-finish="isTradeFinish"
      :is-merchant-pay="isMerchantPay"
      @close="dialogIsShow = false"
    >
    </sh-dialog>
    <!-- 领取返利弹窗错误 -->
    <sh-icon-dialog v-if="receiptDialogShow" :msg="orderErrorMsg" :show-cancel-btn="true" cancel-text="联系客服" confirm-text="我知道了" @cancel="contactCs" @confirm="receiptDialogShow = false">
    </sh-icon-dialog>
    <!-- 取消订单弹窗 -->
    <cancel-order-popup
      :isShow="isShowCancelOrderPopup"
      :isShowChangeKeyWordBtn="isShowChangeKeyWordBtn"
      :isWaitingSearch="isWaitingSearch"
      @changeKeyWord="customChangeKeyWordEvent"
      @confirm="customCancelSaleTaskAccept"
      @close="closeCancelOrderPopup"
    ></cancel-order-popup>
  </div>
</template>

<script>
import orderHandler from '@/mixins/orderHandler'
import ShNavbar from '@/components/smartComponent/SHnavbar2'
import SegementLine from '@/components/puppetComponent/SegementLine'
import ShDialog from './children/ShDialog'
import ShIconDialog from '@/components/puppetComponent/ShIconDialog'
import { Search } from 'vant'
import { MessageBox, Indicator, Toast } from 'mint-ui'
import { EvaluateAllInfo, SaleTaskToCompleteList, SaleWaitReceiveList, FinishEvaluateInfo } from '@/api/my'
import cancelOrder from '@/mixins/cancelOrder'

export default {
  mixins: [orderHandler, cancelOrder],
  data() {
    return {
      haveMore: false,
      scrollDisabled: false,
      tabTitle: ['全部', '待完成', '待收货', '已完成'],
      currentTabIndex: 0,
      dataList: [],
      pageScrollTop: 0,
      // 物流是否签收
      isLogisticsFinished: false,
      // 是否出存在‘待审核’信息
      isExistLogisticsAudit: false,
      // 淘宝是否确认收货
      isTradeFinish: false,
      // 商家是否支付
      isMerchantPay: false,
      taskId: '',
      productId: '',
      dialogIsShow: false,
      receiptDialogShow: false,
      orderErrorMsg: '',
      platformType: 0, // 0：淘宝，1：天猫，2：拼多多
      currentPage: 1,
      page: 1,
      pageCount: 1,
      isKeepAlive: false,
      navbarElem: null,
      // 是否触发tabChange方法
      isEmitChange: false,
      SearchKey: ''
    }
  },
  components: {
    ShNavbar,
    SegementLine,
    ShDialog,
    ShIconDialog,
    'van-search': Search
  },
  mounted() {
    // this.currentTabIndex = this.$route.query.tabIndex ? parseInt(this.$route.query.tabIndex) : 0
    // if (this.currentTabIndex === 0) {
    //   this.fetchData()
    // }
    this.$nextTick(() => {
      this.navbarElem = document.querySelector('.my-navbar')
      this.navbarElem.addEventListener('scroll', this.handleScroll)
    })
  },
  beforeDestroy() {
    this.navbarElem.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    reFetchPage(from) {
      let routeNames = ['goodsDetail', 'balance', 'ShareByImg', 'complaintDetail', 'complaintPage', 'orderSearchDetail', 'order']
      // 详情页进入时的标记，由此标记则会请求数据（既不是按返回按钮进入此页面）
      let flag = this.$route.query.flag
      if (routeNames.indexOf(from.name) !== -1 && !flag) {
        this.$nextTick(() => {
          this.navbarElem.scrollTop = this.pageScrollTop
        })
        // 以下3行代码顺序不可打乱
        this.isKeepAlive = true
        this.currentTabIndex = this.$route.query.tabIndex ? parseInt(this.$route.query.tabIndex) : 0
        this.isKeepAlive = false
      } else {
        this.SearchKey = ''
        this.isKeepAlive = false
        this.dataList = []
        this.dataList.splice(0)
        this.pageScrollTop = 0
        this.scrollDisabled = false
        this.currentPage = 1
        this.page = 1
        this.pageCount = 1
        this.haveMore = false
        this.isEmitChange = false
        this.currentTabIndex = this.$route.query.tabIndex ? parseInt(this.$route.query.tabIndex) : 0
        // 此句不要删除。使用keepAlive时会触发下方【tabChange】方法
        if (this.currentTabIndex === 0) {
        }
        setTimeout(() => {
          // 不触发【tabChange】时，手动调用
          if (!this.isEmitChange) this.tabChange(this.currentTabIndex, true)
        }, 0)
      }
    },
    fetchData() {
      let params = { page: this.currentPage }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      switch (this.currentTabIndex) {
        case 0:
          // 全部
          EvaluateAllInfo(params)
            .then((res) => {
              this.setResData(res)
              this.scrollDisabled = false
              Indicator.close()
            })
            .catch((res) => {
              this.haveMore = false
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
          break
        case 1:
          // 待完成
          SaleTaskToCompleteList(params)
            .then((res) => {
              this.setResData(res)
              this.scrollDisabled = false
              Indicator.close()
            })
            .catch((res) => {
              this.haveMore = false
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
          break
        case 2:
          // 待收货
          SaleWaitReceiveList(params)
            .then((res) => {
              this.setResData(res)
              this.scrollDisabled = false
              Indicator.close()
            })
            .catch((res) => {
              this.haveMore = false
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
          break
        case 3:
          // 已完成
          FinishEvaluateInfo(params)
            .then((res) => {
              this.setResData(res)
              this.scrollDisabled = false
              Indicator.close()
            })
            .catch((res) => {
              this.haveMore = false
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
          break
        default:
          this.haveMore = false
          this.scrollDisabled = false
          Indicator.close()
          break
      }
    },
    setResData(res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.page = res.PaginationViewModel.Page
      this.pageCount = res.PaginationViewModel.PageCount
      if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
        this.haveMore = false
      }
    },
    /**
     * isManual: 是否为手动调用，默认false
     */
    tabChange(val, isManual = false) {
      if (!isManual) this.currentTabIndex = val
      this.dataList = []
      this.currentPage = 1
      this.haveMore = true
      this.isEmitChange = true
      if (!this.isKeepAlive) {
        this.pageScrollTop = 0
        this.fetchData()
      }
      this.isKeepAlive = false
      this.$router.replace({
        name: 'order',
        query: {
          tabIndex: val,
          d: Date.now()
        }
      })
    },
    // 自定义订单页面取消订单方法
    orderPageCancel(orderInfo) {
      this.handelCancelOrder(orderInfo)
      this.cancelOrder()
    },
    // 自定义取消订单按钮成功和失败失败后的操作
    customCancelSaleTaskAccept({ orderCancelReason = '' }) {
      this.cancelSaleTaskAccept({
        orderCancelReason: orderCancelReason,
        success: () => {
          this.reFetchPage('order')
        },
        fail: (errMsg) => {
          if (errMsg === '任务已取消') {
            this.reFetchPage('order')
            Toast('任务已取消，无需重复操作')
          } else {
            this.reFetchPage('order')
            Toast(errMsg)
          }
        }
      })
    },
    // 自定义切换关键词按钮成功和失败失败后的操作
    customChangeKeyWordEvent() {
      this.changeKeyWord({
        success: (orderInfo) => {
          this.submitSearch(orderInfo)
        },
        fail: this.fetchOpenShouhuoData
      })
    },
    // 进入基础销量模式第一步页面
    // goBaseSaleStepOne(itemData) {
    //   let isFreeCard = false;
    //   if (itemData.OrderType) isFreeCard = true;
    //   let toRouteName = "baseStepOne";
    //   let queryData = {
    //     productId: itemData.ProductID,
    //     isFreeCard: isFreeCard,
    //   };
    //   if (itemData.ShopType === 2) {
    //     toRouteName = "pddBaseStepOne";
    //     queryData.taskId = itemData.TaskID;
    //   } else {
    //     queryData.wAPPicUrl = encodeURI(itemData.PicUrl);
    //   }
    //   // 进入购买第一步
    //   this.$router.push({
    //     name: toRouteName,
    //     query: queryData,
    //   });
    // },
    // 联系客服
    contactCs() {
      this.receiptDialogShow = false
      this.$router.push({
        name: 'posterDetail',
        query: {
          isContact: 1
        }
      })
    },
    // 滚动监听
    handleScroll() {
      this.pageScrollTop = this.navbarElem.scrollTop
    },
    loadMore() {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchData()
    },
    onSearch() {
      if (this.SearchKey === '') {
        this.$toast('请先输入商品名称或订单编号搜索')
        return
      }
      this.$router.push({
        name: 'orderSearchDetail',
        query: {
          SearchKey: this.SearchKey
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    MessageBox.close()
    this.dialogIsShow = false
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from)
    })
  }
}
</script>

<style scoped>
@import './orderItem.css';
.main .my-navbar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow-y: scroll;
  min-height: 100vh;
}
.order .searchBtn {
  color: #e6161e;
}
</style>
